import { isFacetVisible, PrimaryFacets } from '../../types.js';

/**
 * Filter out the facets that should not be visible.
 * If we have a received a sort order
 * the facets will be sorted according to the `facetOrder`
 */ function parseFacets({ facets , hasProductType , facetOrder  }) {
    const filteredFacets = facets.filter(isFacetVisible).filter(({ id  })=>hasProductType || PrimaryFacets[id]
    );
    if (!(facetOrder === null || facetOrder === void 0 ? void 0 : facetOrder.length)) {
        return filteredFacets;
    }
    return sortFacets(filteredFacets, facetOrder);
}
/**
 * This function sorts the facets based on order from the `facetOrder` array
 * If the the facet does not exist in the `facetOrder` array, the sorting is kept as is.
 */ function sortFacets(facets, facetOrder) {
    const facetsCopy = Array.from(facets);
    const sorted = facetsCopy.sort((facetA, facetB)=>{
        const orderA = facetOrder.indexOf(facetA.attribute);
        const orderB = facetOrder.indexOf(facetB.attribute);
        // if only one of the facets is not found in the facetOrder sort accordingly
        if (orderA === -1 && orderB !== -1 || orderA !== -1 && orderB === -1) {
            return orderA === -1 ? 1 : -1;
        }
        return orderA - orderB;
    });
    return sorted;
}

export { parseFacets };
//# sourceMappingURL=parse-facets.js.map
